module.exports = __webpack_public_path__ + "icon-phone-big.png?b46aa3e6995bd767fab9e0f89047c92e";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon-phone-big.png
// module id = 587
// module chunks = 26